import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_stock_replenishment_run_order_fulfillment_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    order_qty_line_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    supplier_guid: fromDatatype.GuidDataFieldInterface;
    location_guid: fromDatatype.GuidDataFieldInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    qty_min_order: fromDatatype.NumericDatatypeInterface;
    qty_max_order: fromDatatype.NumericDatatypeInterface;
    qty_recommend_ai: fromDatatype.NumericDatatypeInterface;
    qty_to_fulfill: fromDatatype.NumericDatatypeInterface;
    qty_to_approve: fromDatatype.NumericDatatypeInterface;
    lead_time_in_days: fromDatatype.IntegerDatatypeInterface;
    last_purchase_price: fromDatatype.NumericDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_stock_replenishment_run_order_fulfillment_line_RowClass implements bl_inv_stock_replenishment_run_order_fulfillment_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    order_qty_line_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    supplier_guid: fromDatatype.GuidDataFieldInterface;
    location_guid: fromDatatype.GuidDataFieldInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    qty_min_order: fromDatatype.NumericDatatypeInterface;
    qty_max_order: fromDatatype.NumericDatatypeInterface;
    qty_recommend_ai: fromDatatype.NumericDatatypeInterface;
    qty_to_fulfill: fromDatatype.NumericDatatypeInterface;
    qty_to_approve: fromDatatype.NumericDatatypeInterface;
    lead_time_in_days: fromDatatype.IntegerDatatypeInterface;
    last_purchase_price: fromDatatype.NumericDatatypeInterface;
    purchase_price: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;

}
